// extracted by mini-css-extract-plugin
export default {"trackingEntry":"trackingEntry--_2jXC"};